// export const baseInfoOptions = [
//   {optionId: 0, optionName: "调查员姓名", optionField: "investigator_name", optionType: "input", optionValue: null},
//   {optionId: 2, optionName: "调查员手机号", optionField: "investigator_phone", optionType: "input", optionValue: null}
// ]

// export const investigatorOptions = [
//   {optionId: 0, optionName: "评分", optionField: "score", optionType: "number", optionValue: null},
//   {optionId: 2, optionName: "明察暗访项目数", optionField: "inspect_project", optionType: "number", optionValue: null},
//   {optionId: 3, optionName: "上报案件数", optionField: "report_case", optionType: "number", optionValue: null},
//   {optionId: 4, optionName: "审核案件数", optionField: "audit_case", optionType: "number", optionValue: null},
//   {optionId: 5, optionName: "案件审核通过率", optionField: "case_pass_ratio", optionType: "number", optionValue: null},
//   {optionId: 6, optionName: "问卷调查项目数", optionField: "wj_project", optionType: "number", optionValue: null},
//   {optionId: 7, optionName: "上报答卷数", optionField: "report_answer", optionType: "number", optionValue: null},
//   {optionId: 8, optionName: "审核答卷数", optionField: "audit_answer", optionType: "number", optionValue: null},
//   {optionId: 9, optionName: "答卷审核通过率", optionField: "answer_pass_ratio", optionType: "number", optionValue: null},
//   {optionId: 10, optionName: "结算项目数", optionField: "settle_project", optionType: "number", optionValue: null},
//   {optionId: 11, optionName: "结算金额(元)", optionField: "settle_amount", optionType: "number", optionValue: null},
//   {optionId: 12, optionName: "添加时间", optionField: "creator_time", optionType: "date", optionValue: null},
//   {optionId: 13, optionName: "更新时间", optionField: "update_time", optionType: "date", optionValue: null},
//   {optionId: 14, optionName: "黑名单", optionField: "status", optionType: "select", optionValue: ["是", "否"]}
// ]

export function handleList(list) {
  return list.map((item, index) => ({
    optionId: index,
    optionName: item.attributeName,
    optionField: item.attributeField,
    optionType: item.attributeType,
    optionValue: item.optionValue
  }))
}
